(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["totwoo-locket-memory-modes"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('totwoo-locket-modes')) {
    customElements.define('totwoo-locket-modes', class extends HTMLElement {
      connectedCallback() {
        this.tabs = [...this.querySelectorAll('[data-mode-tab]')];
        this.panels = [...this.querySelectorAll('[data-mode-panel]')];
        this.tabs.forEach((tab) => tab.addEventListener('click', () => this.select(tab.dataset.modeTab)));
        this.tabs.forEach((tab, index) => tab.addEventListener('keydown', (event) => {
          if (event.key !== 'ArrowLeft' && event.key !== 'ArrowRight') return;
          event.preventDefault();
          const direction = event.key === 'ArrowRight' ? 1 : -1;
          const next = this.tabs[(index + direction + this.tabs.length) % this.tabs.length];
          next.focus();
          this.select(next.dataset.modeTab);
        }));
        if (window.Shopify && Shopify.designMode) {
          document.addEventListener('shopify:block:select', (event) => {
            const tab = this.querySelector(`[data-mode-tab="${event.detail.blockId}"]`);
            if (tab) this.select(event.detail.blockId);
          });
        }
      }
      select(id) {
        this.tabs.forEach((tab) => {
          const active = tab.dataset.modeTab === id;
          tab.classList.toggle('is-active', active);
          tab.setAttribute('aria-selected', active ? 'true' : 'false');
        });
        this.panels.forEach((panel) => { panel.hidden = panel.dataset.modePanel !== id; });
      }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["tw907-connection"] && !Shopify.designMode) return;
  try {
    
  (()=>{function init(root){root.querySelectorAll('[data-twc-duplex]').forEach(section=>{if(section.dataset.duplexReady)return;section.dataset.duplexReady='1';const stage=section.querySelector('.tw907-interaction-stage');const buttons=[...section.querySelectorAll('[data-twc-send]')];const circles=buttons.map(button=>button.querySelector('.tw907-node-circle'));const message=section.querySelector('[data-twc-message]');const status=section.querySelector('[role="status"]');const reduced=matchMedia('(prefers-reduced-motion: reduce)').matches;if(!stage||buttons.length<2||circles.some(circle=>!circle))return;const finger=document.createElement('span');finger.className='twc-demo-finger';finger.setAttribute('aria-hidden','true');finger.innerHTML='<svg viewBox="0 0 24 24" width="46" height="46" fill="none" stroke="currentColor" stroke-width="1.55" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M9 11V4.8a1.8 1.8 0 0 1 3.6 0V10 3.8a1.8 1.8 0 0 1 3.6 0v6.8-4.7a1.8 1.8 0 0 1 3.6 0v7.2c0 4.8-2.8 7.4-7 7.4h-1.2c-2.4 0-4.2-1-5.4-3L3.7 13a1.7 1.7 0 0 1 2.8-1.9L9 14"/></svg>';stage.appendChild(finger);let timers=[],autoTimer=null,direction=0,destroyed=false;const later=(fn,delay)=>{const id=setTimeout(fn,delay);timers.push(id);return id};const clearSequence=()=>{timers.forEach(clearTimeout);timers=[];section.classList.remove('twc-signal-moving','twc-signal-reverse');finger.classList.remove('is-ready','is-pressing');circles.forEach(circle=>circle.classList.remove('twc-source-glow','twc-receiver-glow'));message?.classList.remove('is-visible')};const placeFinger=index=>{const stageBox=stage.getBoundingClientRect(),circleBox=circles[index].getBoundingClientRect();finger.style.left=(circleBox.left-stageBox.left+circleBox.width*.58)+'px';finger.style.top=(circleBox.top-stageBox.top+circleBox.height*.46)+'px'};const run=(from=0,automatic=false)=>{clearSequence();direction=from;const to=1-from;placeFinger(from);if(reduced){circles[from].classList.add('twc-source-glow');later(()=>{circles[from].classList.remove('twc-source-glow');circles[to].classList.add('twc-receiver-glow');status&&(status.textContent=section.dataset.received||'')},120);later(clearSequence,1050);return}finger.classList.add('is-ready');later(()=>{finger.classList.add('is-pressing');circles[from].classList.add('twc-source-glow')},520);later(()=>{finger.classList.remove('is-ready','is-pressing');section.classList.toggle('twc-signal-reverse',from===1);section.classList.add('twc-signal-moving');message?.classList.add('is-visible')},980);later(()=>{section.classList.remove('twc-signal-moving');circles[from].classList.remove('twc-source-glow');circles[to].classList.add('twc-receiver-glow');if(status)status.textContent=section.dataset.received||''},1980);later(()=>{clearSequence();if(automatic&&!destroyed)scheduleAuto(1800)},3300)};const scheduleAuto=delay=>{clearTimeout(autoTimer);if(!reduced&&!destroyed)autoTimer=setTimeout(()=>run(0,true),delay)};buttons.forEach((button,index)=>button.addEventListener('click',()=>{clearTimeout(autoTimer);run(index,false);scheduleAuto(5900)}));const onResize=()=>{if(finger.classList.contains('is-ready'))placeFinger(direction)};window.addEventListener('resize',onResize,{passive:true});section._duplexCleanup=()=>{destroyed=true;clearTimeout(autoTimer);clearSequence();window.removeEventListener('resize',onResize)};scheduleAuto(900)})}if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',()=>init(document),{once:true});else init(document);document.addEventListener('shopify:section:load',event=>init(event.target));document.addEventListener('shopify:section:unload',event=>event.target.querySelectorAll('[data-twc-duplex]').forEach(section=>section._duplexCleanup?.()))})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["tw907-products"] && !Shopify.designMode) return;
  try {
    

(() => {

  if (window.tw907ShopReady) return;

  window.tw907ShopReady = true;

  function init(root) {

    root.querySelectorAll('[data-tw907-shop]').forEach(section => {

      if (section.dataset.bound) return;

      section.dataset.bound = 'true';

      const track = section.querySelector('.tw907-shop-track');
      const interactionAbort = new AbortController();
      const interactionOptions = {signal:interactionAbort.signal};
      const findCard = event => event.target.closest?.('.tw907-shop-card') || Array.from(track.querySelectorAll('.tw907-shop-card')).find(card => card.dataset.tw910Block === event.detail?.blockId);
      const selectCard = event => {
        const card=findCard(event);
        if(!card || !track.contains(card)) return;
        track.querySelectorAll('.tw910-selected').forEach(other=>other.classList.remove('tw910-selected'));
        card.classList.add('tw910-selected');
      };
      document.addEventListener('shopify:block:select',selectCard,interactionOptions);
      document.addEventListener('shopify:block:deselect',event=>{
        const card=findCard(event);if(card&&track.contains(card))card.classList.remove('tw910-selected');
      },interactionOptions);
      track.addEventListener('pointerover',event=>{
        const card=findCard(event);if(card)card.classList.add('tw910-pointer');
      },interactionOptions);
      track.addEventListener('pointerout',event=>{
        const card=findCard(event);if(card&&!card.contains(event.relatedTarget))card.classList.remove('tw910-pointer');
      },interactionOptions);
      track.addEventListener('pointerup',selectCard,interactionOptions);
      const edgeObserver = new IntersectionObserver(entries => entries.forEach(entry => entry.target.classList.toggle('tw910-peeking', entry.intersectionRatio < .95)), {root:track, threshold:[0,.5,.95,1]});
      track.querySelectorAll('.tw907-shop-card').forEach(card=>edgeObserver.observe(card));

      const dots = section.querySelector('.tw907-shop-dots');
      const secondaryTrack = section.querySelector('.tw907-shop-secondary-track');

      const motion = () => matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth';

      secondaryTrack?.addEventListener('keydown', event => {
        if (!['ArrowLeft','ArrowRight'].includes(event.key)) return;
        event.preventDefault();
        secondaryTrack.scrollBy({left:(event.key === 'ArrowRight' ? 1 : -1) * secondaryTrack.clientWidth * .82,behavior:motion()});
      });

      function updateDots() {

        const max = Math.max(0, track.scrollWidth - track.clientWidth);

        track.classList.toggle('tw907-can-drag', max > 2);
        const count = max > 2 ? Math.ceil(track.scrollWidth / track.clientWidth) : 0;

        if (dots.children.length !== count) {

          dots.replaceChildren();

          for (let i = 0; i < count; i++) {

            const dot = document.createElement('button');

            dot.type = 'button'; dot.className = 'tw907-shop-dot';

            dot.setAttribute('aria-label', section.dataset.pageLabel + ' ' + (i + 1));

            dot.addEventListener('click', () => track.scrollTo({left:i * (track.scrollWidth - track.clientWidth) / (count - 1), behavior:motion()}));

            dots.append(dot);

          }

        }

        const selected = max ? Math.round(track.scrollLeft / max * (count - 1)) : 0;

        [...dots.children].forEach((dot, i) => dot.setAttribute('aria-current', String(i === selected)));

      }


      const dragAbort = new AbortController();
      let drag = null, suppressDragClick = false;
      const endDrag = event => {
        if (!drag || (event && event.pointerId !== drag.id)) return;
        const id = drag.id;
        drag = null;
        track.classList.remove('tw907-is-dragging');
        if (track.hasPointerCapture(id)) track.releasePointerCapture(id);
      };
      track.addEventListener('pointerdown', event => {
        if (event.pointerType === 'touch' || event.button !== 0 || !event.isPrimary) return;
        suppressDragClick = false;
        if (track.scrollWidth <= track.clientWidth + 2 || event.target.closest('button,summary,select,input,textarea,video')) return;
        drag = {id:event.pointerId,x:event.clientX,y:event.clientY,left:track.scrollLeft,moved:false};
      }, {signal:dragAbort.signal});
      window.addEventListener('pointermove', event => {
        if (!drag || event.pointerId !== drag.id) return;
        const dx = event.clientX - drag.x, dy = event.clientY - drag.y;
        if (!drag.moved) {
          if (Math.abs(dx) < 8) return;
          if (Math.abs(dy) > Math.abs(dx)) { endDrag(event); return; }
          drag.moved = true;
          suppressDragClick = true;
          track.classList.add('tw907-is-dragging');
          track.setPointerCapture(event.pointerId);
        }
        event.preventDefault();
        track.scrollLeft = drag.left - dx;
      }, {passive:false,signal:dragAbort.signal});
      window.addEventListener('pointerup', endDrag, {signal:dragAbort.signal});
      window.addEventListener('pointercancel', endDrag, {signal:dragAbort.signal});
      track.addEventListener('lostpointercapture', endDrag, {signal:dragAbort.signal});
      window.addEventListener('blur', () => endDrag(), {signal:dragAbort.signal});
      track.addEventListener('dragstart', event => {
        if (track.scrollWidth > track.clientWidth + 2 && event.target.closest('img,a')) event.preventDefault();
      }, {signal:dragAbort.signal});
      track.addEventListener('click', event => {
        if (!suppressDragClick || event.detail === 0) return;
        suppressDragClick = false;
        event.preventDefault();
        event.stopImmediatePropagation();
      }, {capture:true,signal:dragAbort.signal});

      let scheduled = false;

      track.addEventListener('scroll', () => { if (!scheduled) {scheduled = true;requestAnimationFrame(() => {scheduled = false;updateDots()})}}, {passive:true});

      track.addEventListener('keydown', event => {

        if (event.target !== track || !['ArrowLeft','ArrowRight'].includes(event.key)) return;

        event.preventDefault();track.scrollBy({left:(event.key === 'ArrowRight' ? 1 : -1) * track.clientWidth * .9,behavior:motion()});

      });

      const resize = new ResizeObserver(updateDots);resize.observe(track);updateDots();

      section.addEventListener('change', event => {

        if (!event.target.matches('select[name=id]')) return;

        const option = event.target.selectedOptions[0];

        const price = event.target.closest('.tw907-shop-card').querySelector('.tw907-shop-price');

        price.querySelector('.tw907-shop-current-price').textContent = option.dataset.price;
        const compare = price.querySelector('.tw907-shop-compare-price');
        compare.textContent = option.dataset.comparePrice || '';
        compare.hidden = !option.dataset.comparePrice;

      });

      section.addEventListener('toggle', event => {

        if (!event.target.matches('.tw907-shop-options') || !event.target.open) return;

        const select = event.target.querySelector('select');

        select.dispatchEvent(new Event('change', {bubbles:true}));

      }, true);

      section.querySelectorAll('.tw907-shop-form').forEach(form => form.addEventListener('submit', async event => {

        event.preventDefault();if (form.dataset.busy) return;

        form.dataset.busy = 'true';

        const button = form.querySelector('button[type=submit]');

        const status = form.querySelector('[role=status]');

        const label = button.innerHTML;

        button.disabled = true;button.setAttribute('aria-busy','true');button.textContent = section.dataset.adding;status.textContent = '';

        try {

          const url = new URL(form.action);url.pathname = url.pathname.replace(/\/$/,'') + '.js';

          const response = await fetch(url, {method:'POST',body:new FormData(form),headers:{Accept:'application/json'},credentials:'same-origin'});

          const product = await response.json();

          if (!response.ok || product.status) throw new Error(product.description || product.message || section.dataset.error);

          status.textContent = section.dataset.added;

          if (document.getElementById('CartDrawer')) document.dispatchEvent(new CustomEvent('ajaxProduct:added',{detail:{product,addToCartBtn:button}}));

          else location.assign(section.dataset.cartUrl);

        } catch (error) {status.textContent = error.message === 'Failed to fetch' ? section.dataset.error : error.message;}

        finally {delete form.dataset.busy;button.disabled = false;button.removeAttribute('aria-busy');button.innerHTML = label;}

      }));

      section._tw907Cleanup = () => { endDrag(); interactionAbort.abort(); dragAbort.abort(); resize.disconnect(); edgeObserver.disconnect(); };

    });

  }

  init(document);

  document.addEventListener('shopify:section:load',event => init(event.target));

  document.addEventListener('shopify:section:unload',event => event.target.querySelectorAll('[data-tw907-shop]').forEach(s => s._tw907Cleanup?.()));

})();


/* Independent pointer handling also works when editor overlays receive events. */
(() => {
 if(window.tw915HoverReady)return;window.tw915HoverReady=true;
 function track(event){
  if(!matchMedia('(min-width:901px)').matches)return;
  document.querySelectorAll('[data-tw907-shop] .tw907-shop-card').forEach(card=>{
   const r=card.getBoundingClientRect();
   const inside=event.clientX>=r.left&&event.clientX<=r.right&&event.clientY>=r.top&&event.clientY<=r.bottom;
   card.classList.toggle('tw915-hover',inside);
  });
 }
 document.addEventListener('pointermove',track,{capture:true,passive:true});
 document.addEventListener('pointerdown',track,{capture:true,passive:true});
 document.addEventListener('mouseleave',()=>document.querySelectorAll('.tw915-hover').forEach(c=>c.classList.remove('tw915-hover')));
 document.addEventListener('shopify:block:select',event=>{
  document.querySelectorAll('[data-tw910-block]').forEach(card=>{
   card.classList.toggle('tw915-editor-selected',card.dataset.tw910Block===event.detail?.blockId||card===event.target||card.contains(event.target));
  });
 });
 document.addEventListener('shopify:block:deselect',()=>document.querySelectorAll('.tw915-editor-selected').forEach(c=>c.classList.remove('tw915-editor-selected')));
})();

(() => {
  const bind = root => root.querySelectorAll('.tw907-shop-secondary-track').forEach(track => {
    if (track.twEqualRows) return;
    let frame;
    const put = (el, props) => { if (el) Object.entries(props).forEach(([name,value]) => { if(el.style.getPropertyValue(name)!==String(value)) el.style.setProperty(name,String(value),'important'); }); };
    const layout = () => {
      const mobile = matchMedia('(max-width:900px)').matches;
      const desktopTrack = track.closest('.tw907-shop-track');
      const featuredCard = desktopTrack.querySelector('.tw907-shop-card-featured');
      if (mobile && featuredCard.dataset.twDesktopSized) {
        [featuredCard,...featuredCard.querySelectorAll('.tw907-shop-media,.tw907-shop-image-link,.tw907-shop-image-link img,.tw907-shop-info,.tw907-shop-name,.tw907-shop-subtitle,.tw907-shop-price,.tw907-shop-quick,.tw907-shop-button,.tw907-shop-name a,.tw907-shop-name span,.tw907-shop-subtitle span')].forEach(el => el.removeAttribute('style'));
        delete featuredCard.dataset.twDesktopSized;
      }
      const cards = mobile ? [...track.children].filter(c=>c.matches('.tw907-shop-card')) : [...desktopTrack.querySelectorAll('.tw907-shop-card')];
      const availableWidth = mobile ? track.clientWidth : desktopTrack.clientWidth;
      if (!cards.length || !availableWidth) return;
      if(!mobile)featuredCard.dataset.twDesktopSized='true';
      const width = mobile ? (availableWidth-16)/2.6 : (availableWidth-36)/4;
      const titleSize = mobile ? Math.max(11,Math.min(14,width*.09)) : 18;
      const descSize = mobile ? 11 : 13;
      const titleLine = Math.ceil(titleSize*1.2);
      const descLine = Math.ceil(descSize*1.3);
      const imageHeight = Math.round(width);
      let titleHeight=titleLine*2,descHeight=descLine*2;
      cards.forEach(card=>{
        put(card,{'box-sizing':'border-box',width:width+'px','max-width':width+'px','min-width':width+'px',flex:'0 0 '+width+'px',display:'grid','grid-template-columns':'minmax(0,1fr)','align-content':'start'});
        const media=card.querySelector('.tw907-shop-media');
        put(media,{padding:'0',width:'100%',height:imageHeight+'px','min-height':imageHeight+'px','max-height':imageHeight+'px','aspect-ratio':'auto','box-sizing':'border-box',position:'relative'});
        put(card.querySelector('.tw907-shop-image-link'),{position:'absolute',inset:'0',width:'100%',height:'100%'});
        card.querySelectorAll('.tw907-shop-image-link img').forEach(img=>put(img,{width:'100%',height:'100%','object-fit':'contain','object-position':'center',transform:'none'}));
        const name=card.querySelector('.tw907-shop-name');
        const desc=card.querySelector('.tw907-shop-subtitle');
        const base={display:'block',height:'auto','min-height':'0','max-height':'none',overflow:'visible','-webkit-line-clamp':'unset',margin:'0',padding:'0',width:'100%','white-space':'normal','overflow-wrap':'anywhere','box-sizing':'border-box'};
        put(name,{...base,'font-size':titleSize+'px','line-height':titleLine+'px'});
        put(desc,{...base,'font-size':descSize+'px','line-height':descLine+'px'});
        [name,desc].forEach(el=>el.querySelectorAll('a,span').forEach(child=>put(child,{'font-size':'inherit','line-height':'inherit','white-space':'normal'})));
        put(name,{display:'-webkit-box','-webkit-box-orient':'vertical','-webkit-line-clamp':'2',overflow:'hidden','max-height':(titleLine*2)+'px'});
        put(desc,{display:'-webkit-box','-webkit-box-orient':'vertical','-webkit-line-clamp':'2',overflow:'hidden','max-height':(descLine*2)+'px'});
      });
      const infoHeight=8+titleHeight+5+descHeight+8+24;
      cards.forEach(card=>{
        put(card,{'grid-template-rows':imageHeight+'px '+infoHeight+'px minmax(50px,auto)',height:'auto','min-height':'0','max-height':'none'});
        put(card.querySelector('.tw907-shop-info'),{display:'grid','grid-template-columns':'minmax(0,1fr)','grid-template-rows':titleHeight+'px '+descHeight+'px 24px','row-gap':'5px',padding:'8px 5px 3px',height:infoHeight+'px','min-height':infoHeight+'px','max-height':infoHeight+'px','align-content':'start','box-sizing':'border-box'});
        put(card.querySelector('.tw907-shop-name'),{height:titleHeight+'px','min-height':titleHeight+'px','max-height':titleHeight+'px'});
        put(card.querySelector('.tw907-shop-subtitle'),{height:descHeight+'px','min-height':descHeight+'px','max-height':descHeight+'px'});
        put(card.querySelector('.tw907-shop-price'),{margin:'0',padding:'0',height:'24px','min-height':'24px','max-height':'24px','font-size':(mobile?Math.min(11,titleSize*.8):14)+'px','line-height':'24px'});
        put(card.querySelector('.tw907-shop-quick'),{margin:'0',padding:'6px 6px 8px',width:'100%','box-sizing':'border-box',height:'auto','min-height':'50px','align-self':'start'});
        card.querySelectorAll('.tw907-shop-button').forEach(button=>put(button,{height:'36px','min-height':'36px','max-height':'36px',width:'100%','box-sizing':'border-box','white-space':'nowrap','font-size':(mobile?9:11)+'px'}));
      });
    };
    const schedule=()=>{cancelAnimationFrame(frame);frame=requestAnimationFrame(layout)};
    const observer=new ResizeObserver(schedule);
    observer.observe(track);
    observer.observe(track.closest('.tw907-shop-track'));
    track.twEqualRows={observer,schedule};
    track.addEventListener('load',schedule,true);
    document.fonts?.ready.then(schedule);
    layout();
  });
  bind(document);
  document.addEventListener('shopify:section:load',event=>bind(event.target));
  document.addEventListener('shopify:section:unload',event=>event.target.querySelectorAll('.tw907-shop-secondary-track').forEach(track=>track.twEqualRows?.observer.disconnect()));
})();


(() => {
  const bind = root => root.querySelectorAll('[data-tw907-shop]').forEach(shop => {
    if (shop.twStableReveal) return;
    const reset = () => shop.querySelectorAll('.tw907-shop-quick').forEach(quick => {
      ['opacity','visibility','pointer-events'].forEach(name => quick.style.removeProperty(name));
    });
    const select = event => {
      const card = [...shop.querySelectorAll('.tw907-shop-card')].find(card => card.dataset.tw910Block === event.detail?.blockId);
      if(card)card.toggleAttribute('data-tw-reveal-selected',event.type==='shopify:block:select');
    };
    shop.addEventListener('click',event => {
      const card=event.target.closest('.tw907-shop-card');
      if(card) {
        shop.querySelectorAll('[data-tw-reveal-selected]').forEach(other=>other.removeAttribute('data-tw-reveal-selected'));
        card.setAttribute('data-tw-reveal-selected','');
      }
    });
    shop.addEventListener('pointerleave',() => shop.querySelectorAll('[data-tw-reveal-selected]').forEach(card=>card.removeAttribute('data-tw-reveal-selected')));
    document.addEventListener('shopify:block:select',select);
    document.addEventListener('shopify:block:deselect',select);
    const observer=new MutationObserver(reset);
    observer.observe(shop,{childList:true,subtree:true});
    shop.twStableReveal={observer,select};
    reset();
  });
  bind(document);
  document.addEventListener('shopify:section:load',event=>bind(event.target));
  document.addEventListener('shopify:section:unload',event=>event.target.querySelectorAll('[data-tw907-shop]').forEach(shop=>{
    const state=shop.twStableReveal;
    if(state) {
      state.observer.disconnect();
      document.removeEventListener('shopify:block:select',state.select);
      document.removeEventListener('shopify:block:deselect',state.select);
    }
  }));
})();

(() => {
  const bind = root => root.querySelectorAll('[data-tw907-shop]').forEach(shop => {
    if (shop.twContainerCarousel) return;
    const track=shop.querySelector('.tw907-shop-secondary-track');
    if(!track)return;
    let frame;
    const set=(el,name,value)=>el.style.setProperty(name,value,'important');
    const clear=(el,names)=>names.forEach(name=>el.style.removeProperty(name));
    const apply=()=>{
      const narrow=shop.getBoundingClientRect().width<820;
      const cards=[...track.querySelectorAll(':scope > .tw907-shop-card')];
      if(narrow){
        const width=Math.max(118,(track.clientWidth-16)/2.6);
        set(track,'display','flex');set(track,'flex-wrap','nowrap');set(track,'gap','8px');
        set(track,'width','100%');set(track,'max-width','100%');set(track,'overflow-x','auto');
        set(track,'overflow-y','hidden');set(track,'scroll-snap-type','x mandatory');
        set(track,'overscroll-behavior-x','contain');set(track,'-webkit-overflow-scrolling','touch');
        cards.forEach(card=>{
          const value=width+'px';
          set(card,'width',value);set(card,'min-width',value);set(card,'max-width',value);
          set(card,'flex','0 0 '+value);set(card,'scroll-snap-align','start');
          const quick=card.querySelector('.tw907-shop-quick');
          if(quick){set(quick,'opacity','1');set(quick,'visibility','visible');set(quick,'pointer-events','auto')}
        });
      }else{
        clear(track,['display','flex-wrap','gap','width','max-width','overflow-x','overflow-y','scroll-snap-type','overscroll-behavior-x','-webkit-overflow-scrolling']);
        cards.forEach(card=>{
          clear(card,['width','min-width','max-width','flex','scroll-snap-align']);
          const quick=card.querySelector('.tw907-shop-quick');
          if(quick)clear(quick,['opacity','visibility','pointer-events']);
        });
      }
    };
    const schedule=()=>{cancelAnimationFrame(frame);frame=requestAnimationFrame(()=>requestAnimationFrame(apply))};
    const observer=new ResizeObserver(schedule);
    observer.observe(shop);observer.observe(track);
    shop.twContainerCarousel={observer,schedule};
    schedule();
  });
  bind(document);
  document.addEventListener('shopify:section:load',event=>bind(event.target));
  document.addEventListener('shopify:section:unload',event=>event.target.querySelectorAll('[data-tw907-shop]').forEach(shop=>shop.twContainerCarousel?.observer.disconnect()));
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["tw913-community"] && !Shopify.designMode) return;
  try {
    
function setupCommunityMotion(root){
  root.querySelectorAll('.tw-carousel-toggle:not([data-ready])').forEach(button=>{
    button.dataset.ready='true';
    button.addEventListener('click',()=>{
      const section=button.closest('[data-tt-community]');
      const paused=section.classList.toggle('tw-carousel-paused');
      button.setAttribute('aria-pressed',String(paused));
      button.textContent=paused?'Automatischen Lauf fortsetzen':'Automatischen Lauf pausieren';
      if(!paused)button.blur();
    });
  });
}
setupCommunityMotion(document);
document.addEventListener('shopify:section:load',event=>setupCommunityMotion(event.target));

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["tw914-features"] && !Shopify.designMode) return;
  try {
    
  (()=>{function init(root){root.querySelectorAll('[data-tw914-features]').forEach(s=>{if(s.dataset.ready)return;s.dataset.ready='1';const buttons=[...s.querySelectorAll('.feature-item')];const images=[...s.querySelectorAll('[data-feature-image]')];function select(b,index){buttons.forEach(x=>{x.classList.toggle('active',x===b);x.setAttribute('aria-expanded',x===b?'true':'false')});images.forEach((image,imageIndex)=>image.classList.toggle('active',imageIndex===index));s.querySelector('.features-left-card').dataset.activeNum=b.dataset.num;s.querySelector('.features-left-top').textContent='FUNKTION '+b.dataset.num;s.querySelector('.features-left-bottom h3').textContent=b.querySelector('.feature-title').textContent.toUpperCase()}buttons.forEach((b,index)=>b.addEventListener('click',()=>select(b,index)));s.addEventListener('shopify:block:select',e=>{const b=e.target.closest('.feature-item');const index=buttons.indexOf(b);if(b&&index>=0)select(b,index)})})}init(document);document.addEventListener('shopify:section:load',e=>init(e.target))})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["twc-hero-carousel"] && !Shopify.designMode) return;
  try {
    
(()=>{
function init(root){
root.querySelectorAll('[data-twc-slider]').forEach(el=>{
if(el.dataset.ready)return;el.dataset.ready='1';
const slides=[...el.querySelectorAll('[data-slide]')],dots=[...el.querySelectorAll('[data-dot]')],pause=el.querySelector('[data-pause]'),status=el.querySelector('[data-slider-status]');
if(!slides.length)return;
let current=0,timer,manualPause=el.dataset.auto!=='true'||matchMedia('(prefers-reduced-motion: reduce)').matches,hover=false,focus=false,visible=true,start=null;
const abort=new AbortController(),options={signal:abort.signal};
function schedule(){clearInterval(timer);if(!manualPause&&!hover&&!focus&&visible&&!document.hidden&&slides.length>1)timer=setInterval(()=>show(current+1,false),3000);}
function syncPause(){if(pause){pause.textContent=manualPause?'▶':'Ⅱ';pause.setAttribute('aria-label',manualPause?'Automatischen Wechsel starten':'Automatischen Wechsel pausieren');}}
function show(index,announce=true){current=(index+slides.length)%slides.length;slides.forEach((s,i)=>s.hidden=i!==current);dots.forEach((d,i)=>d.setAttribute('aria-current',String(i===current)));if(announce)status.textContent=slides[current].getAttribute('aria-label');schedule();}
el.querySelector('[data-prev]')?.addEventListener('click',()=>show(current-1),options);
el.querySelector('[data-next]')?.addEventListener('click',()=>show(current+1),options);
dots.forEach((dot,i)=>dot.addEventListener('click',()=>show(i),options));
pause?.addEventListener('click',()=>{manualPause=!manualPause;syncPause();schedule();},options);
el.addEventListener('mouseenter',()=>{hover=true;schedule()},options);el.addEventListener('mouseleave',()=>{hover=false;schedule()},options);
el.addEventListener('focusin',()=>{focus=true;schedule()},options);el.addEventListener('focusout',e=>{focus=el.contains(e.relatedTarget);schedule()},options);
el.addEventListener('keydown',e=>{if(e.key==='ArrowLeft'||e.key==='ArrowRight'){e.preventDefault();show(current+(e.key==='ArrowRight'?1:-1))}},options);
el.addEventListener('pointerdown',e=>{if(e.pointerType==='touch')start={x:e.clientX,y:e.clientY}},options);
el.addEventListener('pointerup',e=>{if(!start)return;const dx=e.clientX-start.x,dy=e.clientY-start.y;start=null;if(Math.abs(dx)>50&&Math.abs(dx)>Math.abs(dy)*1.5)show(current+(dx<0?1:-1));},options);
el.addEventListener('pointercancel',()=>start=null,options);
document.addEventListener('visibilitychange',schedule,options);
el.addEventListener('shopify:block:select',e=>{const i=slides.findIndex(s=>s===e.target||s.contains(e.target));if(i>=0){manualPause=true;syncPause();show(i)}},options);
const observer=new IntersectionObserver(entries=>{visible=entries[0].isIntersecting;schedule()});observer.observe(el);
el._cleanup=()=>{clearInterval(timer);observer.disconnect();abort.abort()};
syncPause();schedule();
});
}
if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',()=>init(document),{once:true});else init(document);
document.addEventListener('shopify:section:load',e=>init(e.target));
document.addEventListener('shopify:section:unload',e=>e.target.querySelectorAll('[data-twc-slider]').forEach(s=>s._cleanup?.()));
})();

  } catch(e) { console.error(e); }
})();
})();
